export default "__VITE_ASSET__d02ae919__"